import { Injectable } from '@angular/core';
import { PaymentResponse } from '../../models/payment/PaymentResponse.model';
import { EntryEnum } from '../../models/flow/entry-enum';

const TOKEN_KEY = 'auth-token';
const ENTRY = 'entry';
const CAMPAIGN_CODE = 'CampaignCode';
const UPDATED_CAMPAIGN_CODE = 'UpdatedCampaignCode';
const CAMPAIGN_SPEED = 'CampaignSpeed';
const UPDATED_CAMPAIGN_SPEED = 'UpdatedCampaignSpeed';
const ORIGINAL_ENTRY = 'OriginalEntry';
const SELECTED_VASSES = 'SelectedVasses';
const DELIVERY_OR_INSTALAION = 'DeliveryOrInstalation';
const IS_EXISTING_CUSTOMER = 'IsExistingCustomer';
const NEXT_SCREEN_FROM_S10 = 'NextScreenFromS10';
const REFRESHED = 'Refreshed';
const ELCT_SELECTED_CAMPAIGN_TITLE = 'ElctSelectedCampaignTitle';
const ELCT_SELECTED_CAMPAIGN_TITLE_DISCOUNT = 'ElctSelectedCampaignTitleDiscount';
const ELCT_SELECTED_CAMPAIGN_SUB_TITLE = 'ElctSelectedCampaignSubTitle';
const AUTHENTICATE_METHOD = 'AuthenticateMethod';
const CUSTOMER_HAS_SMART_METER = 'CustomerHasSmartMeter';
const URL_CELLO_SIGN = 'UrlCelloSign';
const SUBSCRIBER_NUMBER = 'SubscriberNumber';
const CUSTOMER_ID = 'CustomerId';
const BRAZE_BASE_PROCESS_EVENT_NAME = 'BrazeBaseProcessEventName';
const BRAZE_EVENT_DATA_CACHE = 'BrazeEventDataCache';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  isElectricityEntry(): boolean {
    return this.getEntry() === EntryEnum.Elct;
  }
  
  signOut(): void {
    window.localStorage.clear();
  }

  saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  removeToken() {
    window.sessionStorage.removeItem(TOKEN_KEY);
  }

  getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  saveCampaignCode(CampaignCode: string): void {
    window.sessionStorage.removeItem(CAMPAIGN_CODE);
    window.sessionStorage.setItem(CAMPAIGN_CODE, CampaignCode);
  }

  removeCampaignCode() {
    window.sessionStorage.removeItem(CAMPAIGN_CODE);
  }

  removeBarValue(val: string) {
    window.sessionStorage.removeItem(val);
  }

  getCustomerPhoneNumber(): string {
    // can be ContactPhoneNumber or MobilePhoneNumber
    return this.getSessionValue('MobilePhoneNumber') || this.getSessionValue('ContactPhoneNumber')
  }

  getCampaignCode(): string {
    return sessionStorage.getItem(CAMPAIGN_CODE);
  }

  saveUpdatedCampaignCode(UpdatedCampaignCode: string): void {
    window.sessionStorage.removeItem(UPDATED_CAMPAIGN_CODE);
    window.sessionStorage.setItem(UPDATED_CAMPAIGN_CODE, UpdatedCampaignCode);
  }

  removeUpdatedCampaignCode() {
    window.sessionStorage.removeItem(UPDATED_CAMPAIGN_CODE);
  }

  getUpdatedCampaignCode(): string {
    return sessionStorage.getItem(UPDATED_CAMPAIGN_CODE);
  }

  /** Will lower case the entry and save */
  saveEntry(entry: EntryEnum): void {
    window.sessionStorage.removeItem(ENTRY);
    window.sessionStorage.setItem(ENTRY, (entry || '').toLowerCase());
  }

  removeEntry() {
    window.sessionStorage.removeItem(ENTRY);
  }

  CleanSessionKey(key: string) {
    window.sessionStorage.removeItem(key);
  }

  getEntry(): EntryEnum {
    return (sessionStorage.getItem(ENTRY) || '') as EntryEnum;
  }

  savePaymentResponse(paymentResponse: any) {
    window.sessionStorage.removeItem('paymentResponse');
    window.sessionStorage.setItem('paymentResponse', paymentResponse);
  }

  getPaymentResponse() {
    return sessionStorage.getItem('paymentResponse');
  }

  setSessionValue(name: string, value: any) {
    sessionStorage[name] = value;
  }

  setSessionObjValue(name: string, value: any) {
    sessionStorage.setItem(name, JSON.stringify(value));
  }

  getSessiobObjValue(name: string): any {
    return JSON.parse(sessionStorage.getItem(name));
  }

  getSessionValue(name: string) {
    const val = sessionStorage[name];
    return (sessionStorage[name] && val !== 'null' && val !== 'undefined') ? sessionStorage[name] : null;
  }

  saveCampaignSpeed(CampaignSpeed: string): void {
    window.sessionStorage.removeItem(CAMPAIGN_SPEED);
    window.sessionStorage.setItem(CAMPAIGN_SPEED, CampaignSpeed);
  }

  removeCampaignSpeed() {
    window.sessionStorage.removeItem(CAMPAIGN_SPEED);
  }

  getCampaignSpeed(): string {
    return sessionStorage.getItem(CAMPAIGN_SPEED);
  }

  saveUpatedCampaignSpeedTitle(UpatedCampaignSpeed: string): void {
    window.sessionStorage.removeItem(UPDATED_CAMPAIGN_SPEED);
    window.sessionStorage.setItem(UPDATED_CAMPAIGN_SPEED, UpatedCampaignSpeed);
  }

  removeUpatedCampaignSpeedTitle() {
    window.sessionStorage.removeItem(UPDATED_CAMPAIGN_SPEED);
  }

  getUpatedCampaignSpeedTitle(): string {
    return sessionStorage.getItem(UPDATED_CAMPAIGN_SPEED);
  }

  saveOriginalEntry(OriginalEntry: string): void {
    window.sessionStorage.removeItem(ORIGINAL_ENTRY);
    window.sessionStorage.setItem(ORIGINAL_ENTRY, OriginalEntry || '');
  }

  removeOriginalEntry() {
    window.sessionStorage.removeItem(ORIGINAL_ENTRY);
  }

  getOriginalEntry(): string {
    return sessionStorage.getItem(ORIGINAL_ENTRY);
  }

  saveSelectedVasses(selectedVasses: string[]): void {
    window.sessionStorage.removeItem(SELECTED_VASSES);
    window.sessionStorage.setItem(SELECTED_VASSES, JSON.stringify(selectedVasses));
  }

  removeSelectedVasses(): void {
    window.sessionStorage.removeItem(SELECTED_VASSES);
  }

  getSelectedVasses(): string[] {
    const selectedVassesVal = window.sessionStorage.getItem(SELECTED_VASSES);
    return selectedVassesVal ? JSON.parse(selectedVassesVal) as string[] : []
  }

  saveDeliveryOrInstalation(DeliveryOrInstalation: 'Delivery' | 'Instalation'): void {
    window.sessionStorage.setItem(DELIVERY_OR_INSTALAION, DeliveryOrInstalation);
  }

  removeDeliveryOrInstalation(): void {
    window.sessionStorage.removeItem(DELIVERY_OR_INSTALAION);
  }

  getDeliveryOrInstalation(): string {
    return window.sessionStorage.getItem(DELIVERY_OR_INSTALAION);
  }

  saveIsExistingCustomer(IsExistingCustomer: boolean): void {
    window.sessionStorage.setItem(IS_EXISTING_CUSTOMER, JSON.stringify(IsExistingCustomer || false));
  }

  getIsExistingCustomer(): boolean | null {
    const isExistingCustomerVal = JSON.parse(window.sessionStorage.getItem(IS_EXISTING_CUSTOMER) || null);
    return (isExistingCustomerVal === true || isExistingCustomerVal === false)
      ? isExistingCustomerVal
      :  null;
  }

  saveNextScreenFromS10(nextScreen: string): void {
    window.sessionStorage.setItem(NEXT_SCREEN_FROM_S10, nextScreen);
  }

  removeNextScreenFromS10(): void {
    window.sessionStorage.removeItem(NEXT_SCREEN_FROM_S10);
  }

  getNextScreenFromS10(): string {
    return window.sessionStorage.getItem(NEXT_SCREEN_FROM_S10);
  }

  saveRefreshed(refreshed: boolean): void {
    window.sessionStorage.setItem(REFRESHED, JSON.stringify(refreshed));
  }

  removeRefreshed(): void {
    window.sessionStorage.removeItem(REFRESHED);
  }

  getRefreshed(): boolean {
    return JSON.parse(window.sessionStorage.getItem(REFRESHED) || 'false');
  }

  saveElctSelectedCampaignTitle(title: string): void {
    window.sessionStorage.setItem(ELCT_SELECTED_CAMPAIGN_TITLE, title);
  }

  getElctSelectedCampaignTitleAndDiscount(): string {
    const titleDiscount = this.getElctSelectedCampaignTitleDiscount();
    return this.getElctSelectedCampaignTitle()
      + (titleDiscount ? ` ${titleDiscount} ` : '');
  }

  getElctSelectedCampaignTitle(): string {
    return window.sessionStorage.getItem(ELCT_SELECTED_CAMPAIGN_TITLE) || '';
  }

  saveElctSelectedCampaignTitleDiscount(title: string): void {
    window.sessionStorage.setItem(ELCT_SELECTED_CAMPAIGN_TITLE_DISCOUNT, title);
  }

  getElctSelectedCampaignTitleDiscount(): string {
    return window.sessionStorage.getItem(ELCT_SELECTED_CAMPAIGN_TITLE_DISCOUNT) || '';
  }

  saveElctSelectedCampaignSubTitle(title: string): void {
    window.sessionStorage.setItem(ELCT_SELECTED_CAMPAIGN_SUB_TITLE, title);
  }

  getElctSelectedCampaignSubTitle(): string {
    return window.sessionStorage.getItem(ELCT_SELECTED_CAMPAIGN_SUB_TITLE) || '';
  }


  saveAuthenticateMethod(authMethod: string): void {
    window.sessionStorage.setItem(AUTHENTICATE_METHOD, authMethod);
  }

  getAuthenticateMethod(): 'credit_card' | 'OTP' | 'client_number' {
    return window.sessionStorage.getItem(AUTHENTICATE_METHOD) as ('credit_card' | 'OTP' | 'client_number');
  }

  saveCustomerHasSmartMeter(hasSmartMeter: boolean): void {
    window.sessionStorage.setItem(
      CUSTOMER_HAS_SMART_METER,
      JSON.stringify(
        typeof hasSmartMeter === 'boolean' ? hasSmartMeter : null
      )
    );
  }

  getCustomerHasSmartMeter(): boolean | null {
    const hasSmartMeterVal = JSON.parse(window.sessionStorage.getItem(CUSTOMER_HAS_SMART_METER));
    return typeof hasSmartMeterVal === 'boolean' ? hasSmartMeterVal : null;
  }

  saveUrlCelloSign(url: string): void {
    window.sessionStorage.setItem(URL_CELLO_SIGN, JSON.stringify(url));
  }

  getUrlCelloSign(): string {
    return JSON.parse(window.sessionStorage.getItem(URL_CELLO_SIGN));
  }

  saveSubscriberNumber(subscriberNumber: string): void {
    window.sessionStorage.setItem(SUBSCRIBER_NUMBER, subscriberNumber);
  }

  getSubscriberNumber(): string {
    return window.sessionStorage.getItem(SUBSCRIBER_NUMBER) || '';
  }

  saveCustomerId(customerId: string): void {
    window.sessionStorage.setItem(CUSTOMER_ID, customerId);
  }

  getCustomerId(): string {
    return window.sessionStorage.getItem(CUSTOMER_ID) || '';
  }

  saveBrazeBaseProcessEventName(brazeBaseProcessEvent: string): void {
    window.sessionStorage.setItem(BRAZE_BASE_PROCESS_EVENT_NAME, brazeBaseProcessEvent);
  }

  getBrazeBaseProcessEventName(): string {
    return window.sessionStorage.getItem(BRAZE_BASE_PROCESS_EVENT_NAME) || 'self_process';
  }

  saveBrazeEventDataCache(brazeEventData: { [key: string]: any }): void {
    if (!brazeEventData) {
      return;
    }
    const brazeEventDataCache = this.getBrazeEventDataCache();
    if (brazeEventDataCache) {
      brazeEventData = { ...brazeEventDataCache, ...brazeEventData };
    }
    this.setSessionObjValue(BRAZE_EVENT_DATA_CACHE, brazeEventData);
  }

  getBrazeEventDataCache(): { [key: string]: any } {
    return this.getSessiobObjValue(BRAZE_EVENT_DATA_CACHE) || {};
  }
}
